import * as T from 'three'
import type { Bed } from './beds'
import { customGeometry, customVerticalProfile, CUSTOM, type Rect } from './custom-layout'

/** One U around the pair, inside the assembly footprint; never across the center aisle. */
export function lowerShiplapPanels(bed: Bed): Rect[] {
  if (!bed.lowerShiplap || bed.kind !== 'custom' || bed.customStyle !== 'divider') return []
  const ladders = customGeometry(bed).ladders
  const end = Math.min(...ladders.map(l => l.y)), t = .75
  return [
    {x:0,y:0,w:bed.width,h:t},
    {x:0,y:t,w:t,h:end-t},
    {x:bed.width-t,y:t,w:t,h:end-t},
  ]
}

export function addLowerShiplap(root: T.Group, bed: Bed) {
  const panels = lowerShiplapPanels(bed)
  if (!panels.length) return
  const group = new T.Group(); group.name = 'lower-shiplap-enclosure'
  const height = customVerticalProfile(bed).deckHeight - CUSTOM.frameDepth
  group.userData.measurementName = 'Lower bunk shiplap enclosure'
  const material = new T.MeshStandardMaterial({color:0xffffff,roughness:.72})
  // Actual shallow joints, not painted dark stripes. Horizontal courses meet at corners.
  panels.forEach((r,side) => {
    // Recessed backing closes the laps so light cannot leak through the joints.
    const back = new T.Mesh(new T.BoxGeometry((side === 0 ? r.w : .125)/12,height/12,(side === 0 ? .125 : r.h)/12),material)
    back.name=`lower-shiplap-${side}-backing`; back.userData.finishPart='frame'
    const x=side === 0 ? r.x+r.w/2 : side === 1 ? r.x+.0625 : r.x+r.w-.0625
    const z=side === 0 ? .0625 : r.y+r.h/2
    back.position.set((x-bed.width/2)/12,height/24,(z-bed.depth/2)/12)
    back.castShadow=true; back.receiveShadow=true; group.add(back)
    for (let y=0; y<height; y+=6) {
      const h=Math.min(6,height-y), gap=y+h<height ? .0625 : 0
      const board=new T.Mesh(new T.BoxGeometry(r.w/12,(h-gap)/12,r.h/12),material)
      board.name=`lower-shiplap-${side}-${y/6}`
      board.userData.finishPart='frame'
      board.position.set((r.x+r.w/2-bed.width/2)/12,(y+(h-gap)/2)/12,(r.y+r.h/2-bed.depth/2)/12)
      board.castShadow=true; board.receiveShadow=true; group.add(board)
    }
  })
  root.add(group)
}
